import { structureDetail, structureWorkersList, structureStatus } from './request';
import topTitle from '@/components/title';
import DeactivateModel from './deactivateModel.vue';
export default {
  components: {
    topTitle,
    DeactivateModel
  },
  data() {
    return {
      infoObj: {},
      data: [],
      deactivateShow: false,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '手机号'
        },
        dataIndex: 'mobile',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '工号'
        },
        dataIndex: 'jobNo',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '部门'
        },
        dataIndex: 'structureName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '邮箱'
        },
        dataIndex: 'email',
        key: '5',
        align: 'center'
      }]
    };
  },
  created() {
    this.getDataFun();
    this.getInfoFun();
  },
  methods: {
    getInfoFun() {
      structureDetail({
        customerId: this.$route.params.customerId,
        structureId: this.$route.params.id
      }).then(res => {
        this.infoObj = res;
      });
    },
    getDataFun() {
      let obj = {
        customerId: this.$route.params.customerId,
        structureId: this.$route.params.id,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      structureWorkersList(obj).then(res => {
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleEnable() {
      structureStatus({
        customerId: this.$route.params.customerId,
        structureId: $route.params.id,
        status: 1
      }).then(() => {
        this.$message.success(this.$t('操作成功'));
        this.getInfoFun();
      });
    },
    handleDeactivate(type) {
      this.deactivateShow = true;
      this.$nextTick(() => {
        this.$refs.deactivateForm.init(this.infoObj, type);
      });
    }
  }
};